// Types that are commented out are not fully implemented yet but are added here for clarity since they exist in backend enum
export enum AlarmZoneType {
    MotionDetection = 0,
    LoiteringDetection = 1,
    // RailDefender = 2,
    ViolentBehaviorDetection = 3,
    UnattendedObjectDetection = 4,
    FallDetection = 5,
}
